import { render, staticRenderFns } from "./editSignet.vue?vue&type=template&id=6a84dd6e&scoped=true"
import script from "./editSignet.vue?vue&type=script&lang=js"
export * from "./editSignet.vue?vue&type=script&lang=js"
import style0 from "./editSignet.vue?vue&type=style&index=0&id=6a84dd6e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a84dd6e",
  null
  
)

export default component.exports